<template lang="html">

  <section class="error-404">
    <h1 style="margin-top: 200px">Parece que la información a la que tratas de acceder ya no existe.</h1>
  </section>

</template>

<script lang="js">
  export default  {
    name: 'error-404',
}
</script>

<style scoped lang="scss">
  .error-404 {

  }
</style>



// WEBPACK FOOTER //
// src/components/views/error-404.vue